<template>
    <Submenu :name="`${parentName}`">
        <!-- 父级名称（无法导航） -->
        <template slot="title">
            <common-icon class="side-menu-item-icon"
                :type="parentItem.icon || ''"
                :size="iconSize" />
            <span>{{ showTitle(parentItem) }}</span>
        </template>
        <!-- 子级菜单 -->
        <template v-for="item in children">
            <template v-if="item.children && item.children.length === 1">
                <side-menu-item v-if="showChildren(item)"
                    :key="`menu-${item.name}`"
                    :parent-item="item"></side-menu-item>
                <menu-item v-else
                    :name="getName(item, true)"
                    :key="`menu-${item.children[0].name}`">
                    <common-icon class="side-menu-item-icon"
                        :type="item.children[0].icon || ''"
                        :size="iconSize" />
                    <span>{{ showTitle(item.children[0]) }}</span>
                </menu-item>
            </template>
            <template v-else>
                <side-menu-item v-if="showChildren(item)"
                    :key="`menu-${item.name}`"
                    :parent-item="item"></side-menu-item>
                <menu-item v-else
                    :name="getName(item)"
                    :key="`menu-${item.name}`">
                    <common-icon class="side-menu-item-icon"
                        :type="item.icon || ''" 
                        :size="iconSize"/>
                    <span>{{ showTitle(item) }}</span>
                </menu-item>
            </template>
        </template>
    </Submenu>
</template>
<script>
import mixin from "./mixin";
import itemMixin from "./item-mixin";

export default {
    name: "SideMenuItem",
    mixins: [mixin, itemMixin],
    props: {
        iconSize: {
            type: Number,
            default: 16
        }
    }
};

</script>
